<dx-popup
    title="Audit History"
    [width]="800"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item
        widget="dxButton"
        location="after"
        [options]="{ text: 'Close', type: 'success', onClick: close }"
    ></dxi-popup-toolbar-item>
    @if (auditLogs) {
        <div>
            <div class="d-flex flex-fill">
                <dx-data-grid
                    #auditLogGrid
                    [dataSource]="auditLogs"
                    keyExpr="id"
                    class="d-flex flex-fill"
                    height="300"
                    (onSelectionChanged)="selectionChange($event)"
                >
                    <dxi-data-grid-column dataField="when" caption="Date" [dataType]="'datetime'" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="entityTypeName" caption="Table" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="action" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="userName" caption="User"></dxi-data-grid-column>
                    <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
                </dx-data-grid>
            </div>
            <div class="d-flex flex-fill mt-3">
                <dx-data-grid #auditLogChangesGrid [dataSource]="auditLogData?.Changes" class="d-flex flex-fill" height="300">
                    <dxi-data-grid-column dataField="ColumnName" caption="Field" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="OriginalValue" caption="Old Value"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="NewValue" caption="New Value"></dxi-data-grid-column>
                    <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
                </dx-data-grid>
            </div>
        </div>
    }
</dx-popup>
